module.exports = __webpack_public_path__ + "fonts/fontello.876948a.woff";